var render, staticRenderFns
import script from "./supermarket_deport.vue?vue&type=script&lang=js&"
export * from "./supermarket_deport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5af4af2')) {
      api.createRecord('b5af4af2', component.options)
    } else {
      api.reload('b5af4af2', component.options)
    }
    
  }
}
component.options.__file = "found/views/kms_new/views/backstage_manage/supermarket_deport/supermarket_deport.vue"
export default component.exports